<template>
  <div class="RightDeals">
    <div class="container-flued">
      <div class="container">
        <div class="row">
          <div class="col-lg-3">
            <h3>Any questions?</h3>
          </div>
          <div class="col-lg-6">
            <h4>Get in touch, we’d love to answer</h4>
          </div>
          <div class="col-lg-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 48 48"
              fill="none"
            >
              <path
                d="M16.9748 20.4856C19.472 24.8768 23.1232 28.528 27.5144 31.0251L29.8731 27.7229C30.6573 26.6253 32.1376 26.2861 33.3216 26.9328C37.0731 28.9821 41.2189 30.2275 45.5437 30.5699C46.9307 30.6797 48 31.8371 48 33.2283V45.1291C48 46.4963 46.9659 47.6419 45.6059 47.7816C44.1928 47.9269 42.7672 48 41.3333 48C18.5056 48 0 29.4944 0 6.66667C0 5.23272 0.0731203 3.80723 0.218374 2.39403C0.358134 1.034 1.50384 0 2.87107 0H14.7718C16.1629 0 17.3203 1.06944 17.4301 2.45624C17.7725 6.78101 19.0179 10.927 21.0672 14.6785C21.7139 15.8624 21.3747 17.3428 20.2771 18.1269L16.9748 20.4856ZM10.2513 18.7339L15.3179 15.1149C13.8813 12.0137 12.8967 8.72488 12.3927 5.33333H5.35752C5.34141 5.77685 5.33333 6.22133 5.33333 6.66667C5.33333 26.5488 21.4512 42.6667 41.3333 42.6667C41.7787 42.6667 42.2232 42.6587 42.6667 42.6424V35.6072C39.2752 35.1032 35.9864 34.1187 32.8851 32.6821L29.2661 37.7488C27.8021 37.18 26.3883 36.5107 25.0331 35.7496L24.8781 35.6613C19.6525 32.6899 15.3102 28.3475 12.3387 23.1219L12.2505 22.9669C11.4893 21.6117 10.8201 20.1979 10.2513 18.7339Z"
                fill="#FFC93C"
              />
            </svg>
            <h5>1-823-653-4721</h5>
          </div>
        </div>
        <!--/row-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnyQuestion',
  props: {
    msg: String,
  },
  methods: {
    goto(selectedName) {
      this.$router.push({ name: selectedName, replace: true });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.RightDeals {
  // background-image: url('@/assets/productBg.png');
  background: rgba(115, 113, 123, 1);
  // background-position: center;
  // background-repeat: no-repeat;
  // background-size: cover;
  padding-bottom: 40px;
  padding-top: 40px;
  h3 {
    color: #fff;
    font-family: Inter;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 1.28px;
    text-transform: capitalize;
  }
  h4 {
    color: #fff;
    font-family: Inter;
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 1.28px;
    text-transform: capitalize;
  }
  h5 {
    color: #fff;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    display: inline-block;
    margin-left: 20px;
  }
  .zCard {
    margin: 20px;
    border-radius: 8px;
    border: 1px solid rgba(0, 52, 120, 0.26);
    background: #73717b;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 30px;
    padding-left: 20px;
    padding-right: 20px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    box-sizing: border-box;
    cursor: pointer;
    img {
      display: inline-block;
    }
    h5 {
      color: #ffc93c;
      font-family: Open Sans;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: 0.96px;
      text-transform: uppercase;
    }
    p {
      color: #fff;
      font-family: Inter;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0.72px;
      text-transform: capitalize;
      margin-top: 10px;
    }
    a {
      border-radius: 8px;
      border: 2px solid #ffc93c;
      color: #fff;
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      padding: 4px 12px;
      text-decoration: none;
    }
  }
}
@media screen and (max-width: 1300px) {
  .RightDeals {
    h3 {
      font-size: 24px;
    }
    h4 {
      font-size: 24px;
    }
    h5 {
      font-size: 18px;
    }
  }
}
@media screen and (max-width: 992px) {
  .RightDeals {
    h3 {
      padding-top: 5px;
      padding-bottom: 5px;
    }
    h4 {
      padding-top: 5px;
      padding-bottom: 5px;
    }
    h5 {
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }
}
</style>
